import DynamicContent from './DynamicContent';

export default DynamicContent;



// WEBPACK FOOTER //
// ./src/DynamicContent/index.js